import { setupSection as animateNumbers } from "./animate-numbers.js?v=4";

const callbacks = [];

//data-fade-in
callbacks.push(() => {
    const items = Array.from(document.querySelectorAll('[data-fade-in]'));

    items.forEach(item => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                start: "top bottom",
                end: "+=600",
                scrub: 1,
            },
            opacity: 0,
            y: 40,
        })

    })
});

// stats-section
callbacks.push(() => {
    const sections = Array.from(document.querySelectorAll('[data-stats-section]'));

    sections.forEach(section => {
        animateNumbers(section);
    })
});

// team-section
callbacks.push(() => {

    const sections = Array.from(document.querySelectorAll('[data-team-section]'));
  
    sections.forEach((section) => {
        const blocks = Array.from(section.querySelectorAll(".team-section-fede-in-item"));

        
        ScrollTrigger.batch(blocks, {
            onEnter: elements => {
              gsap.from(elements, {
                opacity: 0,
                y: 16,
                stagger: 0.1
              });
            }
        });
    })
});


callbacks.forEach(f => f());